import { CommonDate, FuzzyDate } from '@hs/ui-core-date';

import { DdvDate } from './ddv-date';

export function resolveDateString(dateString: string | undefined, fuzzyDates: FuzzyDate[]): CommonDate | undefined {
    if (!dateString) {
        return undefined;
    }

    if (DdvDate.isStringValidDate(dateString)) {
        return createCommonDateFromUnknownFormat(dateString);
    }

    const option = fuzzyDates.find((fd) => fd.name.toLocaleUpperCase() === dateString.toLocaleUpperCase());
    return option?.commonDate;
}

function createCommonDateFromUnknownFormat(dateString: string): CommonDate | undefined {
    try {
        return CommonDate.fromDashFormat(dateString);
    } catch (_e1) {
        try {
            return CommonDate.fromUSFormat(dateString);
        } catch (_e2) {
            try {
                return CommonDate.fromEUFormat(dateString);
            } catch (_e3) {
                try {
                    return CommonDate.fromCalendarFormat(dateString);
                } catch (_e4) {
                    return undefined;
                }
            }
        }
    }
}
